module.exports = __webpack_public_path__ + "img/campana-credential.b0a63a7b.png";